package com.milta.feature.route.presentation

/** User intents for the web dashboard's Supervision screen (MIL-48, DOM-06). */
sealed interface WebDashboardIntent {
    /** Switches to [WebDashboardTab.Today] and (re)loads it. Equivalent to `SwitchTab(Today)` —
     * kept as its own intent since the ticket calls for it explicitly (e.g. a dedicated tab button). */
    data object LoadToday : WebDashboardIntent

    /** Switches to [WebDashboardTab.Tomorrow] and (re)loads it. Equivalent to `SwitchTab(Tomorrow)`. */
    data object LoadTomorrow : WebDashboardIntent

    data class SwitchTab(val tab: WebDashboardTab) : WebDashboardIntent

    /** Manual refetch of the currently selected tab — no automatic polling (explicit PO decision). */
    data object Refresh : WebDashboardIntent

    /** Toggles the stop-detail panel for [routeId] — loads `GET /routes/{id}` via
     * [com.milta.feature.route.domain.usecase.GetRouteDetailUseCase] on first expand, collapses it
     * (no re-fetch) if the same, already-expanded route is clicked again. */
    data class ExpandRoute(val routeId: String) : WebDashboardIntent
}
